
<template >
  <!-- eslint-disable max-len -->
  <div class="text-yellow-700 text-sm">
    <p>A parent's superannuation generally cannot be passed on to an adult child as a reversionary pension.  The one exception here is if the child is suffering from a disability. There is a specific definition of disability for this purpose found in Section 8(1) of the Disability Services Act 1986.  Broadly speaking it includes people who are suffering from a disability that:</p>
    <ol class="mt-2 ml-8  list-alpha">
      <li>is attributable to an intellectual, psychiatric, sensory or physical impairment or a combination of such impairments;</li>
      <li>is permanent or likely to be permanent; and</li>
      <li>results in:
        <ol class="mt-2 ml-8 list-roman">
          <li>a substantially reduced capacity of the person for communication, learning or mobility; and</li>
          <li>the need for ongoing support services</li>
        </ol>
      </li>
    </ol>
  </div>
  <!-- eslint-enable max-len -->
</template>
<script>
export default {
  name: 'warning-25-and-over',
};
</script>
